import React from "react";
import { Box, Typography } from "@mui/material";
import Breadcrumb from "../../components/common/breadcrumb/Breadcrumb";

const breadcrumb = ["FDP Zipcode"];

const FdpZipcode = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Breadcrumb pageNameList={breadcrumb} />
      <Typography variant="subtitle2">FDP Zipcode</Typography>
    </Box>
  );
};

export default FdpZipcode;
